import React from 'react';
import PropTypes from 'prop-types';

import SetShippingAddressFormv2 from '../SetShippingAddressFormv2';

function RegistryVisibility({
  showShippingAddressForm,
  onPublishRegistry,
  onSetShippingAddress,
  onSkip,
}) {
  return (
    <div
      id="registry-visibility"
      className={`registry-visibility ${!showShippingAddressForm ? 'has-shipping-address' : ''}`}
    >
      {showShippingAddressForm ? (
        <div>
          <div className="modal-header">
            <h1 className="align-left shipping-header">Please Add Your Shipping Address</h1>
            <p className="instructions text-muted align-left">
              Make sure your gifts are shipped to the right place before your registry is visible.
            </p>
          </div>
          <div className="modal-body">
            <div className="shipping-form-container">
              <SetShippingAddressFormv2
                onSuccess={onSetShippingAddress}
                submitButtonText="Continue"
                secondaryButtonText="Skip"
                secondaryButtonAction={onSkip}
                secondaryButtonClassName="skip-publish-registry"
              />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="modal-header">
            <h1 className="shipping-header align-left">Please Confirm Your Shipping Address</h1>
            <p className="instructions text-muted align-left">
              Make sure your gifts are shipped to the right place before your registry is visible.
            </p>
          </div>
          <div className="modal-body">
            <div className="shipping-form-container">
              <SetShippingAddressFormv2
                onSuccess={onPublishRegistry}
                submitButtonText="Continue"
                submitButtonAction={onPublishRegistry}
                secondaryButtonText="Skip"
                secondaryButtonAction={onSkip}
                secondaryButtonClassName="skip-publish-registry"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

RegistryVisibility.propTypes = {
  showShippingAddressForm: PropTypes.bool,
  onPublishRegistry: PropTypes.func.isRequired,
  onSetShippingAddress: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
};

export default RegistryVisibility;



// WEBPACK FOOTER //
// ./src/components/manage/common/HidePagesModal/RegistryVisibility.jsx